<template>
  <div class="mobile-search-box" v-if="getSearchInputState">
    <div class="search-button" @click="onSearch">
      <font-awesome-icon :icon="['fas', 'search']" class="icon" />
    </div>
    <div class="input-box">
      <input type="text" @keypress.enter="onSearch" v-model="query" @input="onInput">
    </div>
    <div class="close-button" @click="onCloseSearch">
      <font-awesome-icon :icon="['fas', 'times']" class="icon" />
    </div>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MobileSearchBox',
  data() {
    return {
      query: '',
      placeholder: '',
      placeholders: [
        "travel",
        "work",
        "a2",
        "b1",
        "teens",
        "adults",
        "kids"
      ]
    }
  },
  methods: {
    ...mapActions('main', ['searchDialog', 'closeSearch', 'openSearchInput', 'closeSearchInput']),
    onSearch() {
      if(this.query.trim() == '') {
        console.log('Empty Query');
        alert.showWarning('Empty Query');
      } else {
        this.searchDialog(this.query);
      }
    },
    onCloseSearch() {
      this.closeSearchInput();
      this.closeSearch();
      this.query = '';
    },
    onInput(event) {
      this.query = event.target.value;
    },
    setRadomPlaceholder() {
      this.placeholder = `Search "${this.placeholders[Math.floor(Math.random() * this.placeholders.length)]}"`;
    }
  },
  computed: {
    ...mapGetters('main', ['getSearchInputState', 'getSearchQuery']),
  },
  mounted() {
    this.setRadomPlaceholder();
  },
  watch: {
    getSearchQuery: function(value) {
      this.query = value;
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-search-box {
  width: 100%;
  height: 3.5rem;
  display: none;
  margin-bottom: 2rem;
  background-color: #11b6a6de;
  border-radius: 0.2rem;
  overflow: hidden;
  @media (max-width: 875px) {
    display: flex;
  }

  .search-button {
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.3rem;
    transition: 0.3s;

    &:hover {
      cursor: pointer;
      background-color: #12af9fde;
    }
  } 

  .input-box {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      width: 100%;
      height: 100%;
      border: none;
      background: none;
      outline: none;
      color: white;
      font-size: 1.2rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;

      &::placeholder {
        color: rgba(255, 255, 255, 0.575);
      }
    }
  }

  .close-button {
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.3rem;
    transition: 0.3s;

    &:hover {
      cursor: pointer;
      background-color: #12af9fde;
    }
  }
}
</style>